import { useOverlayState } from "@heroui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Spinner } from "@/src/common/components/ui";

interface WelcomeBackModalProps {
	firstName: string;
	redirectUrl: string;
	isOpen: boolean;
}

const COUNTDOWN_START = 5;

export function WelcomeBackModal({ firstName, redirectUrl, isOpen }: WelcomeBackModalProps) {
	const { t } = useTranslation("auth");
	const [count, setCount] = useState(COUNTDOWN_START);

	const state = useOverlayState({ isOpen });

	useEffect(() => {
		if (!isOpen) return;

		setCount(COUNTDOWN_START);

		const interval = setInterval(() => {
			setCount((prev) => {
				if (prev <= 1) {
					clearInterval(interval);
					window.location.href = redirectUrl;
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [isOpen, redirectUrl]);

	return (
		<Modal state={state}>
			<Modal.Backdrop isDismissable={false}>
				<Modal.Container>
					<Modal.Dialog>
						<Modal.Body className="flex flex-col items-center gap-6 py-6">
							<div className="flex flex-col items-center gap-2">
								<p className="text-7xl">🎉</p>
							</div>
							<h2 className="text-xl font-semibold text-center">{t("welcome_back", { firstName })}</h2>
							<div className="flex items-center justify-center gap-2">
								<Spinner color="current" size="sm" />
								<p className="text-muted text-xs">{t("redirecting_in", { count })}</p>
							</div>
						</Modal.Body>
					</Modal.Dialog>
				</Modal.Container>
			</Modal.Backdrop>
		</Modal>
	);
}
